import { Route, Routes, BrowserRouter } from "react-router-dom";
import { IndexPage } from "./pages/IndexPage";
import { DiagnosisPage } from "./pages/DiagnosisPage";
import { ResultPage } from "./pages/ResultPage";
import "./styles/bootstrap.min.css";
import "./styles/main.css";
import "./styles/responsive.css";
import "./styles/animate.min.css";
import "@fontsource/noto-sans-jp";
import "./styles/style.css";

function App() {
	return (
		<BrowserRouter basename="/diagnosis/">
			<Routes>
				<Route path="/" element={<IndexPage />} />
				<Route path="/choice/:region" element={<DiagnosisPage />} />
				<Route path="/result/:id" element={<ResultPage />} />
			</Routes>
		</BrowserRouter>
	);
}

export default App;
